module.exports = __webpack_public_path__ + "img/DE02617.5a392dfc.svg";